import { App, View } from "@pimo/pimo-app-builder";
import { DragAndDropLayout, PMProgressBar } from "@pimo/pimo-components";
import { getLocalizedMessage } from "@pimo/pimo-l10n";

import { TestAppState } from "../../../app";
import { getPluralOfItemName } from "../../../utils/get-plural-of-item-name";

/** Adds the reporting progress card (#2222). */
export function addReportingProgressCard(
  view: View<TestAppState, DragAndDropLayout>,
  app: App<TestAppState>
) {
  const language = app.getAppState().language || "en";

  const reportingProgressComponent = view.addComponent({
    component: PMProgressBar,
    layoutProps: {
      componentId: "reportingProgressComponent",
      labels: ["progress"],
      description:
        getLocalizedMessage(language, "showsReportingProgress") ||
        "Shows the reporting progress of the project.",
      title: getLocalizedMessage(language, "progress") || "Progress",
    },
  });

  reportingProgressComponent.mapState(
    ({ currentReport, language, settings }) => {
      const itemName =
        getPluralOfItemName(settings?.configuration?.itemName, language) ??
        "Items";
      return {
        label: getLocalizedMessage(language, "progress") || "Progress",
        title: itemName,

        trackColor: "#EEE",
        barColor: "#38BDF8",
        percent: currentReport?.project?._calculated?.averageProgress ?? 0,
      };
    }
  );

  reportingProgressComponent.mapVisibility(
    ({ settings }) =>
      settings?.configuration?.fieldsDefinition
        ?.filter((field) => field.purpose === "itemReporting")
        .find((field) => field.fieldName === "progress")?.enabled === true
  );
}
